import styled from '@emotion/styled';
import { ToastContainer as _ToastContainer } from 'react-toastify';
import { borderRadius } from '../../foundations/borders/borderRadius';
import { elevationShadow } from '../../foundations/elevation/elevation';
import { color } from '../../foundations/modes/colors/colors';

export const ToastContainer = styled(_ToastContainer)`
  .Toastify__toast {
    box-shadow: ${elevationShadow.e200};
    padding: 0;
    border-radius: ${borderRadius.rounded8};
  }
  .Toastify__toast-body {
    padding: 0;
  }
  .Toastify__progress-bar {
    background: ${color.accent.secondary.background};
  }
`;
